import React, { useState, useEffect, Fragment } from "react";
import axios from "axios";
import { useLocation } from "react-router-dom";
import { Dialog, Transition } from '@headlessui/react';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import {
  HiOutlineUsers,
  HiPlus,
  HiOutlineBriefcase,
  HiOutlineUser,
  HiMagnifyingGlass,
  HiChevronLeft,
  HiChevronRight,
  HiOutlineTrash
} from "react-icons/hi2";
import { useToast } from "../../components/ui/ToastContext";
import { jwtDecode } from 'jwt-decode';
import { API_URL } from "../../config";

const getInitials = (name) => {
  if (!name) return "U";
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function DashboardCard07() {
  const { showToast } = useToast();
  const location = useLocation();
  const { item: initialData } = location.state || {};
  const [selectedEditRowData, setSelectedEditRowData] = useState(initialData);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [data, setData] = useState([]);
  const [Manage1, setManage1] = useState([]);
  const [Manage, setManage] = useState([]);
  const [open, setOpen] = useState(false);
  const [modalSearchQuery, setModalSearchQuery] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [user, setUser] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const token = localStorage.getItem('jwtToken');

  const getTargetUserId = () => {
    if (selectedEditRowData?.user_id) return selectedEditRowData.user_id;
    if (initialData?.user_id) return initialData.user_id;
    if (token) {
      try {
        const decoded = jwtDecode(token);
        return decoded?.userId;
      } catch (e) {
        console.error(e);
      }
    }
    return null;
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false);
    }, 600);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (token) {
      try {
        const decoded = jwtDecode(token);
        setUser(decoded);
      } catch (error) {
        console.error('Error decoding the token:', error);
      }
    }
  }, [token]);

  const fetchManageData = () => {
    const targetUserId = getTargetUserId();
    if (!targetUserId) return;
    axios
      .get(`${API_URL}/api/manageuser`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        const users = response.data.filter(
          (item) => Number(item.manager_user_id) === Number(targetUserId)
        );

        if (users.length > 0) {
          const subordinateUserId = users.map((item) => Number(item.subordinate_user_id));

          axios
            .get(`${API_URL}/api/users`, {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              const matchedUsers = response.data.filter((item) =>
                subordinateUserId.includes(Number(item.user_id))
              );
              setData(matchedUsers);
            })
            .catch((error) => {
              console.error("Error fetching users data:", error);
            });
        } else {
          setData([]);
        }
      })
      .catch((error) => {
        console.error("Error fetching manage data:", error);
      });
  };

  useEffect(() => {
    const selectProducerIds = data.map((item) => item.user_id);
    const select = Manage1.filter((item) => !selectProducerIds.includes(item.user_id));
    setManage(select);
  }, [data, Manage1]);

  useEffect(() => {
    const targetUserId = getTargetUserId();
    if (targetUserId) {
      axios
        .get(`${API_URL}/api/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          const uniqueManageData = response.data.reduce((acc, current) => {
            if (!acc.some(u => u.user_id === current.user_id)) {
              acc.push(current);
            }
            return acc;
          }, []);
          fetchManageData();
          setManage1(uniqueManageData);
        })
        .catch((error) => {
          console.error("Error fetching users data:", error);
        });
    }
  }, [selectedEditRowData, initialData]);

  const uniqueUsers = data
    .filter((u, index, self) => index === self.findIndex((item) => item.user_id === u.user_id))
    .filter((u) => {
      if (!searchQuery.trim()) return true;
      const q = searchQuery.toLowerCase().trim();
      return (
        u.user_name_surname?.toLowerCase().includes(q) ||
        u.role_name?.toLowerCase().includes(q)
      );
    });

  const totalPages = Math.ceil(uniqueUsers.length / itemsPerPage) || 1;
  const currentItems = uniqueUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      deleteRowuser();
    }
  }, [selecteddeleteuser]);

  const deleteRowuser = async () => {
    const targetUserId = getTargetUserId();
    if (!selecteddeleteuser || !targetUserId) return;

    try {
      await axios.put(
        `${API_URL}/api/deletemanageuser/${targetUserId}`,
        {
          subordinate_user_id: selecteddeleteuser.user_id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
      );
      showToast({
        message: "Accesul utilizatorului a fost șters cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-emerald-600 dark:text-emerald-500" />,
      });
      setSelecteddeleteuser(null);
      fetchManageData();
    } catch (error) {
      console.error("Error deleting user access:", error);
      showToast({
        message: "Eroare la ștergerea accesului!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleToggleUser = (userId) => {
    setSelectedUsers((prev) =>
      prev.includes(userId) ? prev.filter((id) => id !== userId) : [...prev, userId]
    );
  };

  const handleSave = async () => {
    const targetUserId = getTargetUserId();
    if (!targetUserId || selectedUsers.length === 0) return;
    try {
      await axios.post(
        `${API_URL}/api/manageusers`,
        {
          manager_user_id: targetUserId,
          subordinate_user_ids: selectedUsers,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
      );

      setOpen(false);
      fetchManageData();
      showToast({
        message: "Utilizatorii au fost asociați cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-emerald-600 dark:text-emerald-500" />,
      });
      setSelectedUsers([]);
    } catch (error) {
      console.error(error);
      showToast({
        message: "Eroare la salvarea utilizatorilor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleButtonClick = async () => {
    setIsLoading(true);
    try {
      await handleSave();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="w-full">
      {showGrid ? (
        <div className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-2xl p-6 shadow-[0_4px_14px_rgba(22,31,50,0.04)] animate-pulse">
          <div className="h-5 bg-gray-200 dark:bg-gray-700 rounded w-44 mb-4"></div>
          <div className="h-44 bg-gray-100 dark:bg-gray-700/50 rounded-xl"></div>
        </div>
      ) : (
        <div className="bg-white dark:bg-gray-800 border border-[#E7EAF0] dark:border-gray-700/60 rounded-2xl shadow-[0_4px_14px_rgba(22,31,50,0.04)] overflow-hidden transition-all duration-200">
          {/* Card Header */}
          <div className="px-6 py-4 border-b border-[#F1F5F9] dark:border-gray-700/60 flex flex-col sm:flex-row sm:items-center justify-between gap-3.5">
            {/* Header Left: Icon, Title & Subtitle */}
            <div className="flex items-center gap-3">
              <div className="w-[34px] h-[34px] rounded-[10px] bg-[#F1EEFF] dark:bg-indigo-950/60 text-[#6755E8] dark:text-indigo-400 flex items-center justify-center shrink-0">
                <HiOutlineUsers className="w-4 h-4" />
              </div>
              <div>
                <h3 className="text-[15px] font-bold text-[#1E293B] dark:text-gray-100 leading-tight">
                  Utilizatori
                </h3>
                <p className="text-xs text-[#64748B] dark:text-gray-400 mt-0.5">
                  Gestionează accesul utilizatorilor în platformă.
                </p>
              </div>
            </div>

            {/* Header Right: Search Field & CTA */}
            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-2.5">
              <div className="relative w-full sm:w-[220px]">
                <HiMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-3.5 h-3.5 pointer-events-none" />
                <input
                  type="text"
                  className="w-full h-[34px] pl-8 pr-3 rounded-lg border border-[#E2E8F0] dark:border-gray-600 bg-white dark:bg-gray-700/50 text-xs text-[#1E293B] dark:text-gray-100 placeholder:text-gray-400 focus:border-[#6755E8] focus:outline-none focus:ring-2 focus:ring-[#6755E8]/10 transition-all"
                  placeholder="Caută utilizator..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  aria-label="Caută utilizator"
                />
              </div>

              {user?.role === "Admin" && (
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="h-[34px] px-3.5 rounded-lg bg-[#6755E8] hover:bg-[#5844E3] text-white text-[11px] font-medium inline-flex items-center justify-center gap-1.5 shadow-xs transition-all duration-150 hover:-translate-y-0.5 cursor-pointer shrink-0"
                >
                  <HiPlus className="w-3.5 h-3.5" />
                  <span>Adaugă utilizator</span>
                </button>
              )}
            </div>
          </div>

          {/* Modal Adaugare Utilizatori */}
          <Transition appear show={open} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={() => setOpen(false)}>
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-200"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in duration-150"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
              >
                <div className="fixed inset-0 bg-black/40 backdrop-blur-xs" />
              </Transition.Child>

              <div className="fixed inset-0 overflow-y-auto">
                <div className="flex min-h-full items-center justify-center p-4 text-center">
                  <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-200"
                    enterFrom="opacity-0 scale-95"
                    enterTo="opacity-100 scale-100"
                    leave="ease-in duration-150"
                    leaveFrom="opacity-100 scale-100"
                    leaveTo="opacity-0 scale-95"
                  >
                    <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-gray-800 p-6 text-left align-middle shadow-2xl transition-all border border-[#E7EAF0] dark:border-gray-700">
                      <Dialog.Title as="h3" className="text-base font-bold text-[#1E293B] dark:text-gray-100">
                        Selectează utilizatori
                      </Dialog.Title>
                      <p className="text-xs text-[#64748B] dark:text-gray-400 mt-1">
                        Alege utilizatorii subordonați pentru acest profil.
                      </p>

                      <div className="mt-4 relative">
                        <HiMagnifyingGlass className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 w-4 h-4" />
                        <input
                          type="text"
                          className="w-full h-9 pl-9 pr-3.5 rounded-lg border border-[#D9DEE8] dark:border-gray-600 bg-[#F8F9FD] dark:bg-gray-700/50 text-xs text-[#1E293B] dark:text-gray-100 placeholder-[#A3AABA] focus:border-[#6755E8] focus:bg-white focus:outline-none"
                          placeholder="Caută în listă..."
                          value={modalSearchQuery}
                          onChange={(e) => setModalSearchQuery(e.target.value)}
                        />
                      </div>

                      <div className="mt-3 max-h-60 overflow-y-auto divide-y divide-gray-100 dark:divide-gray-700/50 rounded-xl border border-[#EEF1F6] dark:border-gray-700/50 p-1">
                        {Manage
                          .filter((u) => u.user_name_surname && u.user_name_surname.toLowerCase().includes(modalSearchQuery.toLowerCase()))
                          .map((u) => (
                            <label
                              key={u.user_id}
                              className="flex items-center gap-3 p-2 hover:bg-gray-50 dark:hover:bg-gray-700/40 rounded-lg cursor-pointer transition-colors"
                            >
                              <input
                                type="checkbox"
                                className="w-4 h-4 rounded text-[#6755E8] focus:ring-[#6755E8] border-gray-300 cursor-pointer"
                                checked={selectedUsers.includes(u.user_id)}
                                onChange={() => handleToggleUser(u.user_id)}
                              />
                              <div className="w-6 h-6 rounded-full bg-[#F0EEFF] text-[#6755E8] text-[9.5px] font-bold flex items-center justify-center shrink-0">
                                {getInitials(u.user_name_surname)}
                              </div>
                              <span className="text-xs font-medium text-[#1E293B] dark:text-gray-200">
                                {u.user_name_surname}
                              </span>
                            </label>
                          ))}
                        {Manage.length === 0 && (
                          <div className="p-4 text-center text-xs text-gray-400">
                            Nu există alți utilizatori disponibili.
                          </div>
                        )}
                      </div>

                      <div className="mt-5 flex justify-end gap-2">
                        <button
                          type="button"
                          className="px-3.5 py-1.5 text-xs font-semibold text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors cursor-pointer"
                          onClick={() => setOpen(false)}
                        >
                          Anulează
                        </button>
                        <button
                          type="button"
                          disabled={isLoading || selectedUsers.length === 0}
                          className="px-4 py-1.5 text-xs font-semibold bg-[#6755E8] hover:bg-[#5844E3] text-white rounded-lg shadow-xs disabled:opacity-50 transition-all cursor-pointer"
                          onClick={handleButtonClick}
                        >
                          {isLoading ? "Se salvează..." : "Salvează"}
                        </button>
                      </div>
                    </Dialog.Panel>
                  </Transition.Child>
                </div>
              </div>
            </Dialog>
          </Transition>

          {/* Table Content */}
          {uniqueUsers.length > 0 ? (
            <div>
              <div className="overflow-x-auto">
                <table className="table-auto w-full text-left">
                  <thead>
                    <tr className="bg-[#F8FAFC] dark:bg-gray-900/40 text-[#64748B] dark:text-gray-400 text-[11px] font-semibold uppercase tracking-wider h-10 border-b border-[#F1F5F9] dark:border-gray-700/60">
                      <th className="px-6 py-2.5">Nume Prenume</th>
                      <th className="px-6 py-2.5 text-center">Rol</th>
                      <th className="px-6 py-2.5 text-center">Status</th>
                      <th className="px-6 py-2.5 text-center">Acțiuni</th>
                    </tr>
                  </thead>

                  <tbody className="divide-y divide-[#F1F5F9] dark:divide-gray-700/40">
                    {currentItems.map((customer) => {
                      const isActive = customer.is_active !== undefined ? Boolean(customer.is_active) : true;
                      return (
                        <tr
                          key={customer.user_id}
                          className="hover:bg-[#F8FAFC] dark:hover:bg-gray-800/60 transition-colors"
                        >
                          {/* User Name & Avatar */}
                          <td className="px-6 py-3.5 whitespace-nowrap">
                            <div className="flex items-center gap-3">
                              <div className="w-8 h-8 rounded-full bg-[#F1F5F9] dark:bg-gray-700 text-[#334155] dark:text-gray-200 text-xs font-semibold flex items-center justify-center shrink-0">
                                {getInitials(customer.user_name_surname)}
                              </div>
                              <span className="text-[13px] font-medium text-[#1E293B] dark:text-gray-100">
                                {customer.user_name_surname}
                              </span>
                            </div>
                          </td>

                          {/* Role */}
                          <td className="px-6 py-3.5 whitespace-nowrap text-center">
                            <div className="inline-flex items-center justify-center gap-1.5 text-xs text-[#334155] dark:text-gray-300 font-normal">
                              {customer.role_name?.toLowerCase().includes("admin") || customer.role_name?.toLowerCase().includes("manager") ? (
                                <HiOutlineBriefcase className="w-3.5 h-3.5 text-gray-400" />
                              ) : (
                                <HiOutlineUser className="w-3.5 h-3.5 text-gray-400" />
                              )}
                              <span>{customer.role_name || "User"}</span>
                            </div>
                          </td>

                          {/* Status */}
                          <td className="px-6 py-3.5 whitespace-nowrap text-center">
                            <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${
                              isActive
                                ? "bg-[#E8F8EE] text-[#128842] dark:bg-emerald-950/60 dark:text-emerald-300"
                                : "bg-[#FEECEB] text-[#E03131] dark:bg-rose-950/60 dark:text-rose-300"
                            }`}>
                              <span className={`w-1.5 h-1.5 rounded-full ${isActive ? 'bg-[#18A957]' : 'bg-[#E03131]'}`}></span>
                              <span>{isActive ? "Activ" : "Inactiv"}</span>
                            </span>
                          </td>

                          {/* Actions */}
                          <td className="px-6 py-3.5 whitespace-nowrap text-center">
                            {user?.role === "Admin" ? (
                              <button
                                type="button"
                                onClick={() => setSelecteddeleteuser(customer)}
                                className="w-8 h-8 rounded-lg inline-flex items-center justify-center text-gray-400 hover:text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-950/40 transition-colors cursor-pointer"
                                title="Șterge asocierea utilizatorului"
                              >
                                <HiOutlineTrash className="w-4 h-4" />
                              </button>
                            ) : (
                              <span className="text-gray-400">-</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination Footer */}
              <div className="px-6 py-3.5 border-t border-[#F1F5F9] dark:border-gray-700/60 flex flex-col sm:flex-row items-center justify-between gap-3">
                <span className="text-xs font-medium text-[#64748B] dark:text-gray-400">
                  Total: {uniqueUsers.length} {uniqueUsers.length === 1 ? "utilizator" : "utilizatori"}
                </span>

                <div className="flex items-center bg-[#F8FAFC] dark:bg-gray-800 p-1 rounded-lg border border-[#E2E8F0] dark:border-gray-700">
                  <button
                    type="button"
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    className="w-7 h-7 flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 disabled:opacity-30 transition-colors cursor-pointer"
                  >
                    <HiChevronLeft className="w-3.5 h-3.5" />
                  </button>

                  {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => {
                    const isActive = page === currentPage;
                    if (
                      page === 1 ||
                      page === totalPages ||
                      (page >= currentPage - 1 && page <= currentPage + 1)
                    ) {
                      return (
                        <button
                          key={page}
                          type="button"
                          onClick={() => setCurrentPage(page)}
                          className={`w-7 h-7 flex items-center justify-center rounded-md text-xs font-medium transition-colors cursor-pointer ${
                            isActive
                              ? "bg-[#1E293B] text-white shadow-xs"
                              : "text-[#64748B] hover:text-[#1E293B] hover:bg-gray-100 dark:hover:bg-gray-700"
                          }`}
                        >
                          {page}
                        </button>
                      );
                    }
                    if (
                      (page === 2 && currentPage > 3) ||
                      (page === totalPages - 1 && currentPage < totalPages - 2)
                    ) {
                      return (
                        <span key={page} className="px-1 text-gray-400 text-xs">
                          ...
                        </span>
                      );
                    }
                    return null;
                  })}

                  <button
                    type="button"
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    className="w-7 h-7 flex items-center justify-center rounded-md text-gray-500 hover:text-gray-900 disabled:opacity-30 transition-colors cursor-pointer"
                  >
                    <HiChevronRight className="w-3.5 h-3.5" />
                  </button>
                </div>

                <div className="flex items-center gap-2">
                  <span className="text-xs font-medium text-[#64748B] dark:text-gray-400">Arată:</span>
                  <select
                    className="h-[34px] min-w-[130px] rounded-lg border border-[#E2E8F0] hover:border-[#CBD5E1] dark:border-gray-600 bg-white dark:bg-gray-700 text-xs font-medium text-[#334155] dark:text-gray-200 pl-3 pr-8 py-1 focus:outline-none focus:border-[#6755E8] focus:ring-2 focus:ring-[#6755E8]/10 transition-all cursor-pointer"
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                  >
                    <option value={5}>5 pe pagină</option>
                    <option value={10}>10 pe pagină</option>
                    <option value={15}>15 pe pagină</option>
                    <option value={uniqueUsers.length || 50}>Toate</option>
                  </select>
                </div>
              </div>
            </div>
          ) : (
            <div className="py-14 px-6 text-center flex flex-col items-center justify-center min-h-[220px]">
              <div className="w-[52px] h-[52px] rounded-[14px] bg-[#F6F5FF] dark:bg-indigo-950/40 text-[#7B6CF0] dark:text-indigo-400 flex items-center justify-center mb-3 shadow-[0_2px_8px_rgba(103,85,232,0.06)]">
                <HiOutlineUsers className="w-6 h-6" />
              </div>
              <p className="text-[14px] font-semibold text-[#1E293B] dark:text-gray-200">
                Niciun utilizator asociat
              </p>
              <p className="text-[12px] text-[#64748B] dark:text-gray-400 mt-1 max-w-xs leading-relaxed">
                Nu există utilizatori asociați în acest moment pentru acest cont.
              </p>
              {user?.role === "Admin" && (
                <button
                  type="button"
                  onClick={() => setOpen(true)}
                  className="mt-4 h-[34px] px-3.5 rounded-[8px] bg-[#6755E8] hover:bg-[#5844E3] text-white text-[11px] font-medium inline-flex items-center gap-1.5 shadow-xs transition-colors cursor-pointer"
                >
                  <HiPlus className="w-3.5 h-3.5" />
                  <span>Adaugă utilizator</span>
                </button>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default DashboardCard07;
